export const getMaritalStatusFilter = state => state.maritalStatus.filter
